// extracted by mini-css-extract-plugin
export default {"logoLP":"Logo_logoLP__fmmt8","logoFAMS":"Logo_logoFAMS__6vQLm","topBar":"Logo_topBar__tffzt"};